import * as C from "../constants"
import { createReducer} from "../utils/misc";

const initialState = {
    invalidKeysCount: {
        isLoading: false,
        isLoaded: false,
        count: null,
    },
};

export default createReducer(initialState, {
    [C.GET_INVALID_KEYS_COUNT_REQUEST]: (state) => ({
        ...state,
        invalidKeysCount:{
            ...state.invalidKeysCount,
            isLoading: true,
        }
    }),
    [C.GET_INVALID_KEYS_COUNT_FAILURE]: (state) => ({
        ...state,
        invalidKeysCount:{
            ...state.invalidKeysCount,
            isLoading: false,
            isLoaded: false,
        }
    }),
    [C.GET_INVALID_KEYS_COUNT_SUCCESS]: (state, payload) => ({
        ...state,
        invalidKeysCount:{
            ...state.invalidKeysCount,
            isLoading: false,
            isLoaded: true,
            count: payload,
        }
    }),
});


// WEBPACK FOOTER //
// ./src/reducers/dashboard.js